module.exports = __webpack_public_path__ + "img/instagram.5161c6fd.svg";